import { Component, OnInit, ViewChild } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { MatPaginator, MatSnackBar, MatTableDataSource } from '@angular/material';
import { KycService } from '../kyc.service';

@Component({
  selector: 'app-kyc-list',
  templateUrl: './kyc-list.component.html',
  styleUrls: ['./kyc-list.component.css']
})
export class KycListComponent implements OnInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  public displayedColumns: string[] = ['legalName', 'created_at', 'action'];
  public dataSource = new MatTableDataSource<any>();
  public dataSource1 :any
  public isFormVisible = false;
  public data: any[] = [];
  sort: any;
  KYCStatus : any
  constructor(public __service: KycService, public router?: Router, public snackBar ?: MatSnackBar) {
  }
  ngOnInit(): void {
    throw new Error('Method not implemented.');
  }

  ngOnInits(): void {
    this.getUserKYCStatus();
    // this.getData()
    throw new Error('Method not implemented.');
  }

  // ngOnInit() {
  //   // Static data
  //   // this.dataSource.data = [
  //   //   {
  //   //     name: 'John Smith',
  //   //     unique_number: 'KYC001',
  //   //     created_at: new Date('2025-05-07'),
  //   //   },
  //   //   {
  //   //     name: 'Bob Johnson',
  //   //     unique_number: 'KYC002',
  //   //     created_at: new Date('2025-05-06'),
  //   //   },
  //   //   {
  //   //     name: 'Alice Brown',
  //   //     unique_number: 'KYC003',
  //   //     created_at: new Date('2025-05-05'),
  //   //   },
  //   // ];
  //   this.getData();
  // }

  ngAfterViewInit() {
    // this.getData();
    this.getUserKYCStatus();

  }

  getUserKYCStatus(){
    this.__service.getUserKYCStatus().subscribe(res=>{
      console.log("KYC data", res)
      this.KYCStatus = res.data[0].kyc_verify_status
    })
  }

  public applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }


  businessInfo:any
  businessData:any = []
  public getData() {
    this.__service.getKYCdata().subscribe(res => {
      console.log("data here", res)
      this.businessInfo = res.data;
      this.businessInfo.forEach(item => {
        this.businessData[item.key] = item.value;
      });
    }, err => {
      console.log(err)
    })
  }

  public onDelete() {
    this.router.navigate(["/kyc/kyc-details"])
    // if (window.confirm("Are you sure you want to delete this item?")) {
    //   this.__service.deleteService(id).subscribe(
    //     (res) => {
    //       console.log("Delete done", res);
    //       this.getData();
    //       this.openSnackBar(res.message, "Clear")
    //     },
    //     (err) => {
    //       console.log(err);
    //     }
    //   );
    // }
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 2000,
    });
  }


  public editIVR(id: any) {
    console.log(id);
    let navigationExtras: NavigationExtras = {
      queryParams: { IVR: id }
    };
    this.router.navigate(["/ivrsetting/edit-ivr"], navigationExtras)
  }

  public onGoPage() {
    this.router.navigate(["/kyc/kyc"])
  }
  public viewKYC(){
    this.router.navigate(["/kyc/kyc-details"])
  }
  public editKYC(){
    this.router.navigate(["/kyc/kyc"])
  }

}

